import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import HelloARView from "./component";
import { setGsGalleryData } from "../car-details/actions";

const mapStateToProps = ({
    carDetails: {
        galleryProps,
        content,
        config
    },
    abExperiment: {
        webCarTour,
        hideImperfectionsDesktop,
        desktopPremiumFeatures
    }
}) => ({
    galleryProps,
    content,
    config,
    webCarTour,
    hideImperfectionsDesktop,
    desktopPremiumFeatures
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
    setGsGalleryDataConnect: setGsGalleryData
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(HelloARView);
